import React from 'react';
import { faReply } from '@fortawesome/free-solid-svg-icons/faReply';
import { faThumbsDown } from '@fortawesome/free-solid-svg-icons/faThumbsDown';

import Button, { BUTTON_SIZES, BUTTON_TYPES } from '@buyside/components/presentation/Button/button';
import Link from '@buyside/components/presentation/Link/link';

import { accessIdeasUrl, messageUrl } from '@buyside/util/urlHelper';

import {
  IntroRequest,
  Maybe,
  useUpdateIntroRequestStatusMutation
} from '@interfaces/graphql-typings';

const { introRequestStatuses } = require('buyside/util/constantsFromRails.json');

import styles from '../ideaStatusBarStyles.scss';

const IdeaStatusAllocator: React.FC<{
  closeBar: () => void;
  employerName: Maybe<string>;
  pendingIntroRequest: Maybe<Pick<IntroRequest, 'id' | 'status' | 'messageThread'>>;
}> = ({ closeBar, employerName, pendingIntroRequest }) => {
  const [handleUpdateIntroRequestStatus, { loading }] = useUpdateIntroRequestStatusMutation();

  const updateIntroRequestStatus = (status: string): void => {
    if (pendingIntroRequest) {
      handleUpdateIntroRequestStatus({
        variables: {
          status,
          introRequestId: pendingIntroRequest.id
        }
      })
        .then(() => closeBar())
        .catch(error => {
          throw error;
        });
    }
  };

  if (pendingIntroRequest?.messageThread) {
    return (
      <div className={styles.ideaStatusAllocatorIntroRequest}>
        {`${employerName} would like the opportunity to chat with your organization. Do you accept their request?`}
        <div>
          <Button
            analyticsTag="open-reply-message"
            isLoading={loading}
            faIcon={faReply}
            onClick={(): void => updateIntroRequestStatus(introRequestStatuses.accepted)}
            size={BUTTON_SIZES.TINY}
            text="Reply"
            type={BUTTON_TYPES.MAJOR}
            url={messageUrl(pendingIntroRequest.messageThread)}
          />
          <Button
            analyticsTag="ignore-request"
            isLoading={loading}
            faIcon={faThumbsDown}
            onClick={(): void => updateIntroRequestStatus(introRequestStatuses.hidden)}
            size={BUTTON_SIZES.TINY}
            text="Decline"
            type={BUTTON_TYPES.DANGER}
          />
        </div>
      </div>
    );
  }

  return (
    <div className={styles.ideaStatusAllocator}>
      You have access to this idea because it is connected to a Fund that is listed on the Cap Intro
      platform. <Link to={accessIdeasUrl()}>Learn How to Access All SumZero Research</Link>
    </div>
  );
};

export default IdeaStatusAllocator;
